import { createFileRoute, isRedirect, Outlet, redirect } from '@tanstack/react-router';
import { AppLayout } from '@/components/AppLayout';
import { isUnauthorized } from '@/lib/errors';
import { meQuery } from '@/lib/session';

/**
 * Everything signed-in renders inside the Nexus shell. The guard loads the
 * user once (cached in the query client), sends anonymous visitors to /login,
 * and keeps users whose role requires 2FA on the security tab until it's set up.
 */
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    try {
      const me = await context.queryClient.ensureQueryData(meQuery());
      if (me.twoFactorSetupRequired && location.pathname !== '/account') {
        throw redirect({ to: '/account', search: { tab: 'security' } });
      }
      return { me };
    } catch (e) {
      if (isRedirect(e)) throw e;
      if (isUnauthorized(e)) throw redirect({ to: '/login', search: { redirect: location.href } });
      throw e;
    }
  },
  component: () => (
    <AppLayout>
      <Outlet />
    </AppLayout>
  )
});
